import { extractListingDataForCart } from './cartHelpers';

const validEntries = (entries, sellerId) =>
  Array.isArray(entries) &&
  entries.length > 0 &&
  !!sellerId &&
  new Set(entries.map(entry => entry?.listing?.id?.uuid)).size === entries.length &&
  entries.every(
    entry =>
      entry?.listing?.id?.uuid &&
      entry.listing.author?.id?.uuid === sellerId &&
      Number.isInteger(entry.quantity) &&
      entry.quantity > 0
  );

// One cart action starts a sequence of independent listing purchases.
// This context stays in checkout session storage, never in payment/API params.
export const createSellerCheckout = (listings, stockDetails) => {
  const sellerId = listings[0]?.author?.id?.uuid;
  const entries = listings.map(listing => ({
    listing,
    quantity: stockDetails.find(item => item.listingId === listing.id.uuid)?.stockCount || 1,
  }));
  if (!validEntries(entries, sellerId)) throw new Error('Checkout must contain one seller only.');
  return { sellerId, entries, index: 0, completedOrders: [] };
};

export const getNextSellerCheckout = (pageData, orderId) => {
  const checkout = pageData?.orderData?.sellerCheckout;
  if (!checkout || !orderId?.uuid) return null;
  const { entries, sellerId, index, completedOrders } = checkout;
  if (
    !validEntries(entries, sellerId) ||
    !Number.isInteger(index) ||
    index < 0 ||
    !Array.isArray(completedOrders) ||
    completedOrders.length !== index ||
    entries[index]?.listing.id.uuid !== pageData.listing?.id?.uuid ||
    completedOrders.some(order => !order?.id || order.id === orderId.uuid)
  )
    return null;

  const next = entries[index + 1];
  if (!next) return null;
  return {
    listing: next.listing,
    orderData: {
      quantity: next.quantity,
      deliveryMethod: pageData.orderData.deliveryMethod,
      cartItems: [{ ...extractListingDataForCart(next.listing), stockCount: next.quantity }],
      sellerCheckout: {
        ...checkout,
        index: index + 1,
        completedOrders: [
          ...completedOrders,
          { id: orderId.uuid, title: pageData.listing.attributes.title },
        ],
      },
    },
  };
};
